import { render, staticRenderFns } from "./NewUsersStatistic.vue?vue&type=template&id=aad00948&scoped=true"
import script from "./NewUsersStatistic.vue?vue&type=script&lang=js"
export * from "./NewUsersStatistic.vue?vue&type=script&lang=js"
import style0 from "./NewUsersStatistic.vue?vue&type=style&index=0&id=aad00948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad00948",
  null
  
)

export default component.exports